var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"careers"},[_c('div',{staticClass:"careers__bg"}),_c('JobApplication')],1)}
var staticRenderFns = []

export { render, staticRenderFns }